// Package imports
import React, { useState } from 'react';

// CSS imports
import './TextEditorLink.css';

// Components
import TextInput from '../../inputs/textInput/TextInput';

// Helper imports
import { isValidHttpUrl } from '../../../helpers/functions/isValidHttpUrl';

// Icon imports
import { IoIosLink } from 'react-icons/io';
import DeleteButton from '../../buttons/deleteButton/DeleteButton';
import ConfirmButton from '../../buttons/confirmButton/ConfirmButton';

type Props = {
  className?: string;
  linkText: string;
  hasPreviousUrl: boolean;
  setLinkText: (x: string) => void;
  setLink: (x: string) => void;
  removeLink: () => void;
};

const TextEditorLink: React.FC<Props> = ({
  className,
  linkText,
  hasPreviousUrl,
  setLinkText,
  setLink,
  removeLink,
}) => {
  const [linkError, setLinkError] = useState('');

  const onChange = (e: any) => {
    setLinkText(e.target.value);
    setLinkError('');
  };

  const triggerSetLink = () => {
    const isValid = isValidHttpUrl(linkText);
    if (isValid) {
      setLink(linkText);
    } else {
      if (linkText === '') {
        setLinkError('Please enter an url');
      } else {
        setLinkError('Please enter a valid url');
      }
    }
  };
  return (
    <div className={`TextEditorLink ${className ? className : ''}`}>
      {/* <div className='link-icon-container'> */}
      <IoIosLink className='link-icon' />
      {/* </div> */}

      <TextInput
        value={linkText}
        name='linkText'
        onChange={onChange}
        errorMessage={linkError}
        className='link-input'
      />
      <ConfirmButton onClick={triggerSetLink} />
      {hasPreviousUrl ? <DeleteButton onClick={removeLink} /> : null}
    </div>
  );
};

export default TextEditorLink;
